import { stipAxios } from '../axios';
import { EXTERNAL_CONTEXT } from 'app/config/urls';

const BASE_ENDPOINT = '/revisao-solicitacao';

const revisionEndpoints = {
    getRevisions: (cdSolicitacao, context = EXTERNAL_CONTEXT) =>
        stipAxios.get(`${context}${BASE_ENDPOINT}/revisoes/${cdSolicitacao}`),
    getActualRevision: (cdSolicitacao, context = EXTERNAL_CONTEXT) =>
        stipAxios.get(`${context}${BASE_ENDPOINT}/atual/${cdSolicitacao}`),
    findRevisions: (params) =>
        stipAxios.post(`${BASE_ENDPOINT}/find`, {
            ...params,
        }),
    saveDocumentRevision: (payload) => stipAxios.post(`${BASE_ENDPOINT}/save`, payload),
    requestRevision: (cdRevisaoSolicitacao) =>
        stipAxios.post(`${BASE_ENDPOINT}/solicitar-ajuste/${cdRevisaoSolicitacao}`, {}),
    getDaysToDeadLine: () => stipAxios.get(`${BASE_ENDPOINT}/prazo`),
};

export default revisionEndpoints;
